module.exports = "/lucky-balls/video/intro_ba.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/video/intro_ba.mp4
// module id = 881
// module chunks = 0